import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const PaymentIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.70001 8.59961C2.70001 8.04732 3.14773 7.59961 3.70001 7.59961H20.3C20.8523 7.59961 21.3 8.04732 21.3 8.59961V17.9996C21.3 18.5519 20.8523 18.9996 20.3 18.9996H3.70001C3.14773 18.9996 2.70001 18.5519 2.70001 17.9996V8.59961Z"
        stroke={strokeColor}
        strokeWidth={1.5}
      />
      <circle
        cx="12"
        cy="13.3002"
        r="2.1"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="M5.29999 4H18.7"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
